import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionFaceSwap from '../../../redux/action/FJActionFaceSwap';
import FJMobileFaceSwapFirst from './FJMobileFaceSwapFirst';
import { useDispatch, useSelector } from 'react-redux';

const FJMobileFaceSwapFirstContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const mobileStep = useSelector(state => state.faceSwap.mobileStep);
    const _onUploadOriginImage = useCallback(
        file => {
            dispatch(FJActionFaceSwap.uploadOriginImageAction(file));
        },
        [dispatch],
    );

    return <FJMobileFaceSwapFirst onUploadOriginImage={_onUploadOriginImage} active={mobileStep === 0} />;
};

export default FJMobileFaceSwapFirstContainer;
